import styled from "@emotion/styled";

export const ReplacementReasonContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "16px",
	padding: "16px"
});

export const ReplacementReasonHeader = styled.h1(({ theme }) => ({
	...theme.project.typography.heading.h5,
	margin: 0,
	color: theme.project.colors.primaryColors.main
}));

export const ReplacementReasonContentContainer = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: "20px",
	display: "flex",
	flexDirection: "column",
	gap: "10px"
}));

export const ReplacementReasonContentHeader = styled.div(({ theme }) => ({
	color: theme.project.colors.fontColors.main,
	h2: {
		...theme.project.typography.heading.h6,
		margin: 0
	},
	span: {
		...theme.project.typography.body.body1
	}
}));

export const ReplacementReasonButtonGroup = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "flex-end",
	gap: "10px",
	"button:last-of-type": {
		width: "350px"
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column-reverse",
		"button:last-of-type": {
			width: "100%"
		}
	}
}));
